import type { DynamicFieldsConfig } from '#types/components/cms/dynamic-fields'
import type { InjectionKey } from 'vue'

export const DynamicFieldsKey: InjectionKey<DynamicFieldsConfig | undefined> = Symbol('DynamicFieldsKey')
